/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface AnnouncementCreateOrUpdate { 
    title: string;
    content?: string;
    wholeKindergarten?: boolean;
    groupUuids?: Array<string>;
    isInternal?: boolean;
    /**
     * Send push notification to parents in the selected groups when this announcement is created.
     */
    notifyParents?: boolean;
    /**
     * Obrázky (JPG, PNG, GIF, HEIC, atd.) nebo prázdný řetězec pro smazání
     */
    images?: Array<Blob>;
    /**
     * Videa (MP4, MOV, AVI, atd.) nebo prázdný řetězec pro smazání
     */
    videos?: Array<Blob>;
    /**
     * Dokumenty (PDF, DOC, XLS, atd.) nebo prázdný řetězec pro smazání
     */
    documents?: Array<Blob>;
}